import { Middleware, UnknownAction } from "@reduxjs/toolkit";
import { authApi } from "@/services/api";
import { resetState } from "../actions";

const authMiddleware: Middleware = (store) => (next) => (action) => {
    const { type } = action as UnknownAction;
    if (type === "auth/logout") {
        store.dispatch(authApi.util.resetApiState());
        store.dispatch(resetState());
    }
    return next(action);
};

export default authMiddleware;
